<template>
  <div v-loading="loading">
    <div class="exchange-detail">
      <i class="iconhuobi iconfont info-icon"></i>
      <div>
        <div class="exchange-info">
          1 {{ $t('system::exchange-manager::dollar') }} = {{ exchange }}
          <!-- <el-input-number v-model="exchange" :min="0" :controls="false"></el-input-number> -->
          {{ $t('system::exchange-manager::rmb') }}
        </div>
        <p class="tips-info">{{ $t('system::exchange-manager::title') }}</p>
      </div>
      <el-button type="default" class="change-btn" @click="onShow">
        <i class="iconedit iconfont edit-icon"></i>
        {{ $t('system::exchange-manager::change_rate') }}
      </el-button>
    </div>
    <rateModal :drawRow="rateRow" @save="onSave" v-model="rowVisable"></rateModal>
  </div>
</template>

<script>
import rateModal from '../components/change-rate-modal'
import { getExchangeRate, updateExchangeRate } from '@/server/system'
export default {
  components: {
    rateModal,
  },
  data() {
    return {
      rateRow: {
        type: 'change',
        item: {},
      },
      rowVisable: false,
      exchange: undefined,
      id: '',
      currencyCode: 'USD',
      loading: false,
    }
  },
  created() {
    this.getRate()
  },
  methods: {
    onShow() {
      this.rateRow = {
        type: 'change',
        item: {
          id: this.id,
          currencyCode: this.currencyCode,
          value: this.exchange,
        },
      }
      this.rowVisable = true
    },
    onSave() {
      this.getRate()
    },
    // v1.09移除
    submitExchange() {
      if (!this.exchange) return this.$message.warning(this.$t('system::exchange-manager::exchange_input'))
      this.$confirm(
        this.$t('system::exchange-manager::confitm_title_tips'),
        this.$t('system::exchange-manager::confitm_title'),
        {
          showCancelButton: true,
          closeOnClickModal: false,
          confirmButtonText: this.$t('system::exchange-manager::confirm'),
          cancelButtonText: this.$t('system::exchange-manager::cancel'),
        }
      ).then(async () => {
        let params = {
          currencyCode: this.currencyCode,
          rate: this.exchange,
        }
        if (this.id) {
          params.id = this.id
        }
        const { data } = await updateExchangeRate(params)
        if (data.code === this.$code) {
          this.$message.success(this.$t('system::tip::control_success'))
          this.getRate()
        }
      })
    },
    async getRate() {
      this.loading = true
      const { data } = await getExchangeRate()
      this.loading = false
      if (data.code === this.$code) {
        if (data.data.length > 0) {
          const last = data.data[data.data.length - 1]
          this.exchange = last.rate || undefined
          this.id = last.id || ''
          this.currencyCode = last.currencyCode || 'USD'
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.exchange-detail {
  display: flex;
  position: relative;
  padding: 16px 0 24px 0;
  padding-right: 140px;

  .exchange-info {
    font-size: 20px;
    font-weight: bold;
    color: #010517;
    line-height: 26px;
  }
  .tips-info {
    font-size: 14px;
    margin-top: 10px;
    color: #666666;
    line-height: 20px;
  }
  .info-icon {
    flex: 0 0 auto;
    width: 64px;
    height: 64px;
    margin-right: 24px;
    font-size: 22px;
    color: #fff;
    line-height: 64px;
    text-align: center;
    background: #0560fd;
    border-radius: 32px;
  }
  .change-btn {
    flex: 0 0 auto;
  }
  .edit-icon {
    font-size: 14px;
    margin-right: 4px;
  }
  .change-btn {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-20px);
  }
}
</style>
